import { createContext } from 'react';

// true when a Reveal is rendered inside a Stagger (parent drives the animation).
export const StaggerContext = createContext(false);
